import { CALL_API, Schemas } from '../../common/middleware/api';

export const GRADES_REQUEST = 'GRADES_REQUEST';
export const GRADES_SUCCESS = 'GRADES_SUCCESS';
export const GRADES_FAILURE = 'GRADES_FAILURE';

export const GRADES_UNPAGED_REQUEST = 'GRADES_UNPAGED_REQUEST';
export const GRADES_UNPAGED_SUCCESS = 'GRADES_UNPAGED_SUCCESS';
export const GRADES_UNPAGED_FAILURE = 'GRADES_UNPAGED_FAILURE';

export const GRADE_FETCH_REQUEST = 'GRADE_GET_REQUEST';
export const GRADE_FETCH_SUCCESS = 'GRADE_GET_SUCCESS';
export const GRADE_FETCH_FAILURE = 'GRADE_GET_FAILURE';

export const GRADE_CREATE_REQUEST = 'GRADE_CREATE_REQUEST';
export const GRADE_CREATE_SUCCESS = 'GRADE_CREATE_SUCCESS';
export const GRADE_CREATE_FAILURE = 'GRADE_CREATE_FAILURE';

export const GRADE_UPDATE_REQUEST = 'GRADE_UPDATE_REQUEST';
export const GRADE_UPDATE_SUCCESS = 'GRADE_UPDATE_SUCCESS';
export const GRADE_UPDATE_FAILURE = 'GRADE_UPDATE_FAILURE';

export const loadGrades = (options) => ({
	[CALL_API]: {
		types: [GRADES_REQUEST, GRADES_SUCCESS, GRADES_FAILURE],
		endpoint: 'api/grades',
		request: options,
		schema: Schemas.GRADE_ARRAY
	}
});

export const loadUnpagedGrades = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [GRADES_UNPAGED_REQUEST, GRADES_UNPAGED_SUCCESS, GRADES_UNPAGED_FAILURE],
		endpoint: 'api/grades/unpaged',
		request: options,
		schema: Schemas.GRADE_ARRAY,
		onSuccessEvent
	}
});

export const fetchGrade = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [GRADE_FETCH_REQUEST, GRADE_FETCH_SUCCESS, GRADE_FETCH_FAILURE],
		endpoint: `api/grades/${id}`,
		schema: Schemas.GRADE,
		onSuccessEvent
	}
});

export const createGrade = (grade, history) => ({
	[CALL_API]: {
		types: [GRADE_CREATE_REQUEST, GRADE_CREATE_SUCCESS, GRADE_CREATE_FAILURE],
		endpoint: 'api/grades',
		method: 'POST',
		request: grade,
		schema: Schemas.GRADE,
		form: 'newGrade',
		transition: {
			history,
			successPath: (response) => {
				return `/grades/${response.result}`;
			}
		}
	}
});

export const updateGrade = (id, grade) => ({
	[CALL_API]: {
		types: [GRADE_UPDATE_REQUEST, GRADE_UPDATE_SUCCESS, GRADE_UPDATE_FAILURE],
		endpoint: `api/grades/${id}`,
		method: 'PUT',
		request: grade,
		schema: Schemas.GRADE,
		form: 'grade'
	}
});